<script>
  import { handleUpsell } from '../../modules/helpers'
  import { createEventDispatcher } from 'svelte';
  import InsertFeatureUpgrade from './templates/Upgrade.svelte'
  import InsertFeatureTeaser from './templates/Teaser.svelte'

  export let insert_position
  export let inbetween_counter
  export let filtered_preview_count

  const dispatch = createEventDispatcher()

</script>

<!-- Before Preview -->
{#if insert_position === 'before_previews'}
  <!-- NOT TRIED YET -->
  {#if filtered_preview_count > 100}
    <InsertFeatureTeaser feature="autoscroll"/>
  {/if}
{/if}

<!-- Between Previews -->
{#if insert_position === 'between_previews'}
  {#if inbetween_counter=== 2}
    <InsertFeatureUpgrade feature="autoscroll"/>
  {/if}    
{/if}